import react from "react";
import GraphNode, { type GraphNodeProps } from "./DebuggerGraphNode";

const GraphNodeFocusMode = (props: GraphNodeProps) => (
  <GraphNode
    {...props}
    includeContextMenu={false}
  />
);

export default GraphNodeFocusMode;
